// Using Google Translate on our app cause to Javascript error (Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node)
// This is a workaround for that issue
// for more info see: https://github.com/facebook/react/issues/11538#issuecomment-417504600
export function patchGoogleTranslateCrash() {
    const _patchGoogleTranslateCrash = () => {
        if (typeof Node === "function" && Node.prototype) {
            const originalRemoveChild = Node.prototype.removeChild;
            Node.prototype.removeChild = function (child) {
                if (child.parentNode !== this) {
                    if (console) {
                        // eslint-disable-next-line no-console
                        console.error("Cannot remove a child from a different parent", child, this);
                    }
                    return child;
                }
                // eslint-disable-next-line prefer-rest-params
                return originalRemoveChild.apply(this, arguments);
            };

            const originalInsertBefore = Node.prototype.insertBefore;
            Node.prototype.insertBefore = function (newNode, referenceNode) {
                if (referenceNode && referenceNode.parentNode !== this) {
                    if (console) {
                        // eslint-disable-next-line no-console
                        console.error(
                            "Cannot insert before a reference node from a different parent",
                            referenceNode,
                            this,
                        );
                    }
                    return newNode;
                }
                // eslint-disable-next-line prefer-rest-params
                return originalInsertBefore.apply(this, arguments);
            };
        }
    };

    const onDOMSubtreeModified = e => {
        const target = e.target as HTMLElement;

        // page has been translated by google translate
        if (target.tagName === "HTML" && target.className.match("translated-rtl")) {
            document.removeEventListener("DOMSubtreeModified", onDOMSubtreeModified, true);
            _patchGoogleTranslateCrash();
        }
    };

    document.addEventListener("DOMSubtreeModified", onDOMSubtreeModified, true);
}
